import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "content homecont"
  }, _vm._l(_vm.recommendList, function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.recommendProductList.length > 0,
        expression: "item.recommendProductList.length > 0"
      }],
      key: index,
      staticClass: "list"
    }, [_c('h3', [_c('span', [_vm._v(_vm._s(item.typeName))]), _c('span', {
      on: {
        "click": function click($event) {
          return _vm.watchMore(item.id);
        }
      }
    }, [_vm._v(" 浏览更多 "), _c('i', {
      staticClass: "iconfont icongengduo"
    })])]), _c('div', {
      staticClass: "list"
    }, [item.recommendProductList.length === 0 ? _c('div', {
      staticClass: "norecord"
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/no_record.png")
      }
    }), _c('span', [_vm._v("暂无数据")])]) : _c('ul', [_c('li', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "advertisement"
    }, [index === 0 ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: 'https://imagepc.ctaiot.com/mall/index_product_type/haocai.aa245f33.png',
        expression: "'https://imagepc.ctaiot.com/mall/index_product_type/haocai.aa245f33.png'"
      }],
      attrs: {
        "alt": ""
      }
    }) : _vm._e(), index === 1 ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: 'https://imagepc.ctaiot.com/mall/index_product_type/biaoqianji.40d5e09b.png',
        expression: "\n                'https://imagepc.ctaiot.com/mall/index_product_type/biaoqianji.40d5e09b.png'\n              "
      }],
      attrs: {
        "alt": ""
      }
    }) : _vm._e(), index === 2 ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: 'https://imagepc.ctaiot.com/mall/index_product_type/saomiaoqiang.adfdabd3.png',
        expression: "\n                'https://imagepc.ctaiot.com/mall/index_product_type/saomiaoqiang.adfdabd3.png'\n              "
      }],
      attrs: {
        "alt": ""
      }
    }) : _vm._e(), index === 3 ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: 'https://imagepc.ctaiot.com/mall/index_product_type/caijiqi.2d7f9b3a.png',
        expression: "'https://imagepc.ctaiot.com/mall/index_product_type/caijiqi.2d7f9b3a.png'"
      }],
      attrs: {
        "alt": ""
      }
    }) : _vm._e(), index === 4 ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: 'https://imagepc.ctaiot.com/mall/index_product_type/shouyinji.4b3d0a4d.png',
        expression: "'https://imagepc.ctaiot.com/mall/index_product_type/shouyinji.4b3d0a4d.png'"
      }],
      attrs: {
        "alt": ""
      }
    }) : _vm._e(), index === 5 ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: 'https://imagepc.ctaiot.com/mall/index_product_type/zhoubian.b9cbfb43.png',
        expression: "'https://imagepc.ctaiot.com/mall/index_product_type/zhoubian.b9cbfb43.png'"
      }],
      attrs: {
        "alt": ""
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "hot-wrap"
    }, _vm._l(item.recommendProductList.slice(0, 8), function (list) {
      return _c('div', {
        key: list.id,
        staticClass: "hot-list",
        on: {
          "click": function click($event) {
            return _vm.goDetails(list.id);
          }
        }
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: list.listImagePath.cdnFilePathPc,
          expression: "list.listImagePath.cdnFilePathPc"
        }]
      }), _c('div', {
        staticClass: "item-details"
      }, [_c('em', {
        staticClass: "product-name"
      }, [_vm._v(_vm._s(list.productName))]), _c('div', {
        staticClass: "price-region"
      }, [_c('Price', {
        attrs: {
          "price": list.lowestPrice.split(',')[0]
        }
      })], 1), _c('div', {
        staticClass: "equity"
      }, [list.discount > 0 ? _c('span', {
        staticClass: "discount"
      }, [_vm._v(_vm._s(list.discount) + "折")]) : _vm._e(), list.coupon ? _c('span', {
        staticClass: "coupon"
      }, [_vm._v("领券")]) : _vm._e(), list.participateIntegral ? _c('span', {
        staticClass: "deduction"
      }, [_vm._v("积分抵现")]) : _vm._e()]), _c('div', {
        staticClass: "sale-word"
      }, [_c('em', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: list.orderMax,
          expression: "list.orderMax"
        }]
      }, [_vm._v("最近购买")]), _c('em', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: list.visitMax,
          expression: "list.visitMax"
        }]
      }, [_vm._v("最近浏览")])])])]);
    }), 0)])])])]);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };